/**
 * Whether an answer about which fields are allowed narrows anything.
 *
 * The settings endpoint answers with a list of the fields a module may show.
 * An empty one is not "none of them" — it is no answer at all: an environment
 * that holds no records of that kind, or a request that did not come back and
 * was caught into an empty array on the way. Read literally it left a table
 * with the one or two columns its structure marks as required — the stocks
 * list came up as a grid of nothing but Actions, with no way for a reader to
 * switch the rest back on.
 * @param {string[] | undefined} fields What the settings endpoint answered.
 * @returns {boolean} True where the answer actually names fields.
 */
export const hasAllowedFields = (fields?: string[]): fields is string[] => !!fields?.length;
